import { render, staticRenderFns } from "./teacherResult.vue?vue&type=template&id=0c9b8c04&scoped=true&lang=html"
import script from "./teacherResult.vue?vue&type=script&lang=js"
export * from "./teacherResult.vue?vue&type=script&lang=js"
import style0 from "./teacherResult.vue?vue&type=style&index=0&id=0c9b8c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b8c04",
  null
  
)

export default component.exports